import { createReducer } from 'redux-act';
import {
  fetchInformationList,
  successFetchInformationList,
  failFetchInformationList,
} from '../actions/information';
//初期状態
const initial = {
  information: {
    items: undefined,
    isFetching: false,
    error: undefined,
  }
};

const information = createReducer({
  [fetchInformationList]: state => Object.assign({}, state, {
    isFetching: true,
    error: undefined
  }),
  [failFetchInformationList]: (state, err) => Object.assign({}, state, {
    isFetching: false,
    error: err
  }),
  [successFetchInformationList]: (state, payload) => Object.assign({}, state, {
    isFetching: false,
    items: payload,
    error: undefined,
  }),
}, initial.information);

export default information;



// WEBPACK FOOTER //
// ./src/reducers/information.js